module.exports = __webpack_public_path__ + "img/logo_light.e8958eee.svg";